import { useEffect, useRef } from 'react';
import { LottieRefCurrentProps } from 'lottie-react';
import { logEvent } from '@/etc/firebase'; // Firebase 이벤트 로깅 함수
import { LayoutCardContainer } from './Layouts';
// import GASection from './GASection';
// import OverviewTopsection from './OverviewTopsection';

import { CardHeader } from './NewsCard';
import { OverviewTopSection } from './OverviewTopSection';
import { GASection } from './GASection';

export const ApageOverview = ({ active }: { active: boolean }) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const hasLoggedRef = useRef(false); // 진입 로그 여부 저장

  useEffect(() => {
    if (active) {
      lottieRef.current?.goToAndPlay(0);

      // 처음 진입한 경우에만 로그
      if (!hasLoggedRef.current) {
        logEvent('enter_page_overview', {
          targetPage: 'pc_page',
        });
        hasLoggedRef.current = true;
      }
    }
  }, [active]);

  return (
    <LayoutCardContainer>
      <CardHeader />
      <div className="flex h-full flex-col justify-center gap-5">
        <OverviewTopSection lottieRef={lottieRef} />
        <GASection />
      </div>
    </LayoutCardContainer>
  );
};
